import apiClient from './apiClient';

export interface UserConsent {
  _id: string;
  user: {
    _id: string;
    username: string;
    name: string;
  };
  consentType: 'terms_of_service' | 'privacy_policy' | 'data_processing' | 'marketing' | 'location' | 'cookies';
  version: string;
  ipAddress?: string;
  userAgent?: string;
  consented: boolean;
  consentedAt: string;
  revokedAt?: string;
  metadata?: Record<string, any>;
  createdAt: string;
  updatedAt: string;
}

class UserConsentService {
  async getUserConsents(userId: string, consentType?: string) {
    const params = new URLSearchParams();
    if (consentType) {
      params.append('consentType', consentType);
    }
    const response = await apiClient.get(`/consents/user/${userId}?${params.toString()}`);
    return response.data;
  }

  async getConsentStatistics(filters?: { consentType?: string; startDate?: string; endDate?: string }) {
    const params = new URLSearchParams();
    if (filters?.consentType) {
      params.append('consentType', filters.consentType);
    }
    if (filters?.startDate) {
      params.append('startDate', filters.startDate);
    }
    if (filters?.endDate) {
      params.append('endDate', filters.endDate);
    }
    const response = await apiClient.get(`/consents/statistics?${params.toString()}`);
    return response.data;
  }
}

export const userConsentService = new UserConsentService();
export default userConsentService;

